export default {
    brush: {
        title: 'Brosse',
        brushHardness: 'Dureté du pinceau',
        brushSize: 'Taille du pinceau',
        brushColor: 'Couleur du pinceau',
    },
};
